<template>
    <div>
        <div class="banner" :style="{backgroundImage:'url('+config.banner+')'}">
            <div class="content">
                <div></div>
                <div class="volunteer" v-loading="loading">
                    <div class="tip" style="margin-bottom: 10px;"></div>
                    <div
                        style="display: flex;justify-content: space-around;align-items: center;width:100%;height:30px;line-height: 30px;">
                        <div class="title" style="font-size: 20px;color: #666666;">AI计算与专家决策完美结合</div>
                        <div class="title" style="width:120px;font-size: 20px;cursor: pointer;color:#999999;"
                             @click="chose_province_fun">
                            <el-icon>
                                <MapLocation :color="'#999999'"/>
                            </el-icon>
                            {{ province_name }}
                        </div>
                    </div>
                    <div class="select" style="border: none;" v-if="show_major_1nd">
                        <div class="name" style="border: none;white-space: nowrap;">
                            <span v-if="show_major_2nd">首选科目</span>
                            <span v-else>科类</span>
                        </div>
                        <div class="ipt">
                            <el-radio @change="first_xuanke_change"
                                      v-model="base_info.subject_three"
                                      v-for="item in gaokaoxuanke.major_1nd"
                                      :label="item.id"
                                      :key="item.id"
                            >
                                <span style="font-size: 16px;color: #999999;">{{ item.name }}</span>
                            </el-radio>
                        </div>
                    </div>
                    <div class="select"
                         style="border: none;display: flex;justify-content: center;align-items: flex-start;"
                         v-if="show_major_2nd">
                        <div class="name" style="border: none;white-space: nowrap;">
                            <span v-if="show_major_1nd">再选科目</span>
                            <span v-else>选科</span>
                        </div>
                        <div class="ipt"
                             style="display: flex;justify-content: center;align-items: center;margin-left: 8px;">
                            <el-checkbox-group v-model="base_info.second" :max="major_2nd_limit"
                                               @change="second_xuanke_change">
                                <el-checkbox v-for="item in gaokaoxuanke.major_2nd" :label="item.id" :key="item.id">
                                    <span style="font-size: 16px;color: #999999;">{{ item.name }}</span>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <div class="select">
                        <div class="name">考试分数</div>
                        <div class="ipt">
                            <el-input v-model="base_info.score" :min="100" :max="score_input_max" @input="score_input">
                                <template #append></template>
                            </el-input>
                        </div>
                    </div>
                    <div class="select" style="border: none;" v-if="show_score_prediction">
                        <div class="name" style="border: none;">成绩类型</div>
                        <div class="ipt">
                            <el-radio @change="prediction_type_change"
                                      v-model="base_info.precedence_type"
                                      v-for="item in gaokaoxuanke.score_prediction"
                                      :label="item.value"
                                      :key="item.text"
                            >
                                {{ item.text }}
                            </el-radio>
                        </div>
                    </div>
                    <div class="select">
                        <div class="name">考试位次</div>
                        <div class="ipt">
                            <el-input v-model="base_info.precedence" :min="0" @input="precedence_input"
                                      @change="precedence_change">
                                <template #append></template>
                            </el-input>
                        </div>
                    </div>
                    <div class="ms-button" @click="chose_plans">智能填志愿</div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="tip">
                <div class="left">
                    <div class="list" v-for="(item, index) in tipData.left" :key="index" @click="left_click_fun(item)">
                        <div class="box">
                            <img :src="item.icon" alt=""/>
                            <div class="text">{{ item.label }}</div>
                        </div>
                        <img
                            v-if="index !== 3"
                            class="icon"
                            src="../../assets/home/right.png"
                            alt=""
                        />
                    </div>
                
                </div>
                <div class="cutOff"></div>
                <div class="right">
                    <div class="box" v-for="(item, index) in tipData.right" :key="index" @click="right_click_fun(item)">
                        <img :src="item.icon" alt=""/>
                        <div class="text">{{ item.label }}</div>
                    </div>
                </div>
            </div>
            <!-- 热门院校 -->
            <div class="category">
                <div class="border"></div>
                <div class="font">热门院校</div>
                <!--                <div class="more">-->
                <!--                    <div>查看更多</div>-->
                <!--                    <div>》</div>-->
                <!--                </div>-->
            </div>
            <div class="school">
                <div class="left">
                    <div class="font1">我的分数<br/>能上哪些大学?</div>
                    <div class="cutOff"></div>
                    <div class="font2">
                        输入模考/高考分数，AI智能推<br/>荐引擎帮你选大学
                    </div>
                    <div class="button" @click="chose_plan">智能填志愿</div>
                </div>
                <div class="right">
                    <div class="list" v-for="(item, index) in hot_school" :key="index" @click="show_school_info(item)">
                        <img :src="item.logo" alt=""/>
                        <div>{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <!-- 名师讲堂 -->
            <div class="category" v-if="mingshi_jiangtang_status">
                <div class="border"></div>
                <div class="font">{{ mingshi_jiangtang_str }}</div>
                <div class="more" @click="mingshijiangtang">
                    <div>查看更多</div>
                    <div>》</div>
                </div>
            </div>
            <div class="teacher" v-if="mingshi_jiangtang_status">
                <div class="list" v-for="(item, index) in home_list['mingshi_jiangtang']" :key="index"
                     @click="mingshijiangtang_xiangqing(item)">
                    <img :src="item.img" alt=""/>
                    <div class="content">
                        <div class="top">{{ item.title }}</div>
                        <div class="bottom">
                            {{ item.author }} | {{ item.created_time_str }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 专家团队 -->
            <div class="category" style="margin-top: 20px" v-if="zhuanjia_tuandui_status">
                <div class="border"></div>
                <div class="font">{{ zhuanjia_tuandui_str }}</div>
                <div class="more" @click="zhuanjiatuandui">
                    <div>查看更多</div>
                    <div>》</div>
                </div>
            </div>
            <div class="expert"  v-if="zhuanjia_tuandui_status">
                <img
                    :src="item.img" style="object-fit: contain;cursor: pointer;margin-bottom: 20px;"
                    v-for="(item, index) in home_list['zhuanjia_tuandui']"
                    :key="index"
                    alt=""
                    @click="zhuanjiatuandui_xiangqing(item)"
                />
            </div>
            <!-- 最新咨询 -->
            <div class="category" style="margin-top: 20px" v-if="zuixin_zixun_status">
                <div class="border"></div>
                <div class="font">{{ zuixin_zixun_str }}</div>
                <div class="more" @click="zuixin_zixun_fun">
                    <div>查看更多</div>
                    <div>》</div>
                </div>
            </div>
            <div class="teacher" v-if="zuixin_zixun_status">
                <div class="list" v-for="(item, index) in home_list['zuixin_zixun']" :key="index"
                     @click="hangyezixun_xiangqing(item)">
                    <img :src="item.img" alt=""/>
                    <div class="content">
                        <div class="top">{{ item.title }}</div>
                        <div class="bottom">
                            {{ item.author }} | {{ item.created_time_str }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 政策解读 -->
            <div class="category" style="margin-top: 20px" v-if="zhengce_jiedu_status">
                <div class="border"></div>
                <div class="font">{{ zhengce_jiedu_str }}</div>
                <div class="more" @click="zhengcejiedu">
                    <div>查看更多</div>
                    <div>》</div>
                </div>
            </div>
            <div class="teacher" v-if="zhengce_jiedu_status">
                <div class="list" v-for="(item, index) in home_list['zhengce_jiedu']" :key="index"
                     @click="zhengce_xiangqing(item)">
                    <img :src="item.img" alt=""/>
                    <div class="content">
                        <div class="top">{{ item.title }}</div>
                        <div class="bottom">
                            {{ item.author }} | {{ item.created_time_str }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 数据分析 -->
            <div class="category" style="margin-top: 20px" v-if="shuju_fenxi_status">
                <div class="border"></div>
                <div class="font">{{ shuju_fenxi_str }}</div>
                <div class="more" @click="shujufenxi">
                    <div>查看更多</div>
                    <div>》</div>
                </div>
            </div>
            <div class="teacher" v-if="shuju_fenxi_status">
                <div class="list" v-for="(item, index) in home_list['shuju_fenxi']" :key="index"
                     @click="shujufenxi_xiangqing(item)">
                    <img :src="item.img" alt=""/>
                    <div class="content">
                        <div class="top">{{ item.title }}</div>
                        <div class="bottom">
                            {{ item.author }} | {{ item.created_time_str }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog v-model="chose_province_status" title="" v-if="show_chose_province"
                   style="padding: 0;background-color: rgba(51, 51, 51, 0.9);border-radius: 6px;" align-center
                   @before-close="before_close" :show-close="false" :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   width="800" :modal="true">
            <div
                style="width: 100%;margin: 0 auto 10px auto;text-align: center;font-size: 16px;font-weight: bold;color: white;">
                选择省份
            </div>
            <div
                style="width:690px;margin:0 auto;display: flex;justify-content: left;align-items: center;flex-wrap: wrap;">
                <div :class="item.use?'gaokao_sheng':'gaokao_sheng_no_chose'" @click="chose_gaokao_sheng(index, item)" v-for="(item, index) in provinces">
                    {{ item.name }}
                </div>
            </div>
        </el-dialog>
        <base_info :msgDialog="edit_user_info" @close_edit_user_info="close_edit_user_info"
                   @reset_base_info_after_register="reset_base_info_after_register_fun"></base_info>
    </div>
</template>

<script>
import left0 from "@/assets/home/left0.png";
import left1 from "@/assets/home/left1.png";
import left2 from "@/assets/home/left2.png";
import left3 from "@/assets/home/left3.png";
import right0 from "@/assets/home/right0.png";
import right1 from "@/assets/home/right1.png";
import right2 from "@/assets/home/right2.png";
import right3 from "@/assets/home/right3.png";
import right4 from "@/assets/home/right4.png";
import right5 from "@/assets/home/right5.png";
import axios from "axios";
import api from "@/api";
import {ElMessageBox, ElNotification} from "element-plus";
import Bind_phone from "@/views/personal/comps/bind_phone.vue";
import Base_info from "@/views/personal/comps/base_info.vue";
import entity from "@/utils/entity";
import merge from 'webpack-merge';

export default {
    components: {Base_info, Bind_phone},
    props: {
        change_menu_action: {
            type: Function,
            default: null
        },
        change_province_status: {
            type: Number,
            default: 0
        },
        reset_base_info_after_register: {
            type: Function,
            default: null
        },
        add_base_info_status: {
            type: Number,
            default: 0
        },
        change_bind_phone: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            config: {
                address: '',
                banner: '',
                bottom_banner: '',
                copyright: '',
                domain: '',
                email: '',
                hotline_phone: '',
                icp: '',
                logo: '',
                name: '',
                phone: '',
                website_title: '',
                wx_mini_url: '',
                wx_offiaccount_url: '',
            },
            edit_user_info: {show: false},
            show_chose_province: true,
            chose_province_status: true,
            hot_school: [
                {
                    'name': '浙江大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/eb6b75745f25fa1e66362052e0e08f4d62e16f87.jpg',
                    'url': '',
                    'school_id': '184',
                },
                {
                    'name': '上海交通大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/598c92b43ae53c11bdbfaa9f1143ab0fabe2354e.jpg',
                    'url': '',
                    'school_id': '195',
                },
                {
                    'name': '复旦大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/58978cb6515f194b491ab8305f386975b391aec2.jpg',
                    'url': '',
                    'school_id': '202',
                },
                {
                    'name': '西安交通大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/ae279abdc4f5a35b18044284fc6568f6070315ec.jpg',
                    'url': '',
                    'school_id': '389',
                },
                {
                    'name': '四川大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/fc436a9dc8d57060ee67ec49ff69e2f6873e1943.jpg',
                    'url': '',
                    'school_id': '169',
                },
                {
                    'name': '南方科技大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/f29f974a02e51eccf5ac4f1152a9f1d3198bb0b0.jpg',
                    'url': '',
                    'school_id': '2496',
                },
                {
                    'name': '北京航空航天大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/4226c1856f019c64ad0accbb6a3ca046b8d8db8f.jpg',
                    'url': '',
                    'school_id': '118',
                },
                {
                    'name': '太原理工大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/51e6abab2a2cb7c2b969d3a547e99853132bf7d8.jpg',
                    'url': '',
                    'school_id': '209',
                },
                {
                    'name': '深圳大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/5b48e7957758956dba233e40ea2cead151537dc2.jpg',
                    'url': '',
                    'school_id': '349',
                },
            ],
            value: "",
            input: "700",
            score_input_max: 750,
            options: [
                {
                    label: "物理",
                    value: "物理",
                },
                {
                    label: "化学",
                    value: "化学",
                },
                {
                    label: "历史",
                    value: "历史",
                },
            ],
            tipData: {
                left: [
                    {
                        label: "填写信息",
                        icon: left0,
                    },
                    {
                        label: "AI选专业",
                        icon: left1,
                    },
                    {
                        label: "选志愿",
                        icon: left2,
                    },
                    {
                        label: "评估报告",
                        icon: left3,
                    },
                ],
                right: [
                    {
                        label: "AI选专业",
                        icon: right0,
                    },
                    {
                        label: "查大学",
                        icon: right1,
                    },
                    {
                        label: "查专业",
                        icon: right2,
                    },
                    {
                        label: "批次线",
                        icon: right3,
                    },
                    {
                        label: "一分一档",
                        icon: right4,
                    },
                    {
                        label: "测录取",
                        icon: right5,
                    },
                ],
            },
            province_name: '河北',
            province_id: '13',
            provinces: [],
            all_provinces: [],
            oss_list_url: [],
            province_list: [],
            chose_province: [],
            gaokaoxuanke_list: [],
            gaokaoxuanke: [],
            wenlike: [],
            form: {
                class_id: 0,
                ben_zhuan: '',
                subject_one: '0',
                subject: []
            },
            base_info: {
                'class_id': 0,
                'score': '',
                'show_score': '',
                'province_id': '',
                'subject_one': 0,
                'subject_two': 0,
                'subject_three': 0,
                'precedence_type': 1,
                'majors': [],
                'second': [],
            },
            score_precedence_1: [],
            score_precedence_1_zhuan: [],
            score_precedence_2: [],
            score_precedence_2_zhuan: [],
            score_precedence_3: [],
            score_precedence_3_zhuan: [],
            score_precedence_list: [],
            show_major_1nd: false,
            show_major_2nd: false,
            show_score_prediction: false,
            gaokaomoshi_type: 0,
            major_2nd_limit: 2,
            oss_url_list: [],
            sheng_oss_url_list: [],
            code: '',
            state: '',
            weixin_login: false,
            teacher_login: false,
            news_domain: 'https://news.shudaozaixian.com/',
            zhengcejiedu_str: '',
            shujufenxi_str: '',
            mingshijiangtang_str: '',
            hangyezixun_str: '最新资讯',
            zhuanjiatuandui_str: '',
            zhengcejiedu_url: '',
            shujufenxi_url: '',
            mingshijiangtang_url: '',
            zhuanjiatuandui_url: '',
            home_list: {
                'mingshi_jiangtang': [],
                'shuju_fenxi': [],
                'zhengce_jiedu': [],
                'zhuanjia_tuandui': [],
                'zuixin_zixun': [],
            },
            home_column: {
                'mingshi_jiangtang': '',
                'shuju_fenxi': '',
                'zhengce_jiedu': '',
                'zhuanjia_tuandui': '',
                'zuixin_zixun': '',
            },
            mingshi_jiangtang_status: false,
            shuju_fenxi_status: false,
            zhengce_jiedu_status: false,
            zhuanjia_tuandui_status: false,
            zuixin_zixun_status: false,
            mingshi_jiangtang_str: '',
            shuju_fenxi_str: '',
            zhengce_jiedu_str: '',
            zhuanjia_tuandui_str: '',
            zuixin_zixun_str: '',
            agent_id: 0,
            agent_open_province: [],
            zuixin_zixun: {img: '', title: '', author: '', desc: '', created_time_str: ''}
        };
    },
    watch: {
        '$route'(to, from) {
            if (to.fullPath !== from.fullPath && to.path === from.path) {
                window.location.reload()
            }
        },
        change_province_status(new_val) {
            this.check_user_info()
            localStorage.removeItem('chose_province_id')
            localStorage.removeItem('chose_province_name')
            this.get_oss_list()
            
            this.get_sheng_oss_list()
        },
        add_base_info_status(new_val) {
            this.edit_user_info.show = true
        }
    },
    created() {
        let local = new URL(window.location.href)
        let that = this
        axios.get(
            'https://oss.shudaozaixian.com/cache/agent_cms_info/list/' + local.hostname + '.json?time=' + new Date().getTime(), {}
        ).then(function (res) {
            if (res.data.domain) {
                that.agent_id = res.data.domain
                localStorage.setItem('domain', res.data.domain)
                
                let url = 'https://oss.shudaozaixian.com/cache/agent_open_province/' + that.agent_id + '.json?time=' + new Date().getTime()
                axios.get(url, {}).then(function (response) {
                    if (response.data) {
                        that.agent_open_province = response.data || []
                    }
                    that.init(res.data.domain)
                }).catch(function (error) {
                    that.init(res.data.domain)
                });
                
                url = 'https://oss.shudaozaixian.com/cache/agent_cms_info/data/' + res.data.domain + '/config.json?time=' + new Date().getTime()
                console.log(url)
                axios.get(url, {}).then(function (response) {
                    if (response.data) {
                        that.config = response.data
                        document.title = that.config.website_title
                    }
                }).catch(function (error) {
                });
                
                url = 'https://oss.shudaozaixian.com/cache/agent_cms_info/data/' + res.data.domain + '/home.json?time=' + new Date().getTime()
                axios.get(url, {}).then(function (response) {
                    if (response.data) {
                        that.home_list = response.data.articles
                        if (that.home_list['zuixin_zixun'] !==undefined && that.home_list['zuixin_zixun'][0]) {
                            that.zuixin_zixun = that.home_list['zuixin_zixun'][0]
                        }
                        for (let i in response.data.column) {
                            if (response.data.column[i]['key'] == 'zhuanjia_tuandui') {
                                that.zhuanjia_tuandui_status = true
                                that.zhuanjia_tuandui_str = response.data.column[i]['name']
                            } else if (response.data.column[i]['key'] == 'zuixin_zixun') {
                                that.zuixin_zixun_status = true
                                that.zuixin_zixun_str = response.data.column[i]['name']
                            } else if (response.data.column[i]['key'] == 'zhengce_jiedu') {
                                that.zhengce_jiedu_status = true
                                that.zhengce_jiedu_str = response.data.column[i]['name']
                            } else if (response.data.column[i]['key'] == 'shuju_fenxi') {
                                that.shuju_fenxi_status = true
                                that.shuju_fenxi_str = response.data.column[i]['name']
                            } else if (response.data.column[i]['key'] == 'mingshi_jiangtang') {
                                that.mingshi_jiangtang_status = true
                                that.mingshi_jiangtang_str = response.data.column[i]['name']
                            }
                        }
                    }
                }).catch(function (error) {
                });
            }
        }).catch(function (err) {
        });
        
        let query = this.$route.query;
        this.weixin_login = false
        this.teacher_login = false
        if (query.token !== undefined && query.token !== 'login') {
            localStorage.removeItem('base_info')
            localStorage.removeItem('jwt')
            localStorage.removeItem('province_id')
            localStorage.removeItem('bind_phone')
            localStorage.removeItem('over_time')
            localStorage.removeItem('login_type')
            localStorage.removeItem('local_url')
            
            this.show_chose_province = false
            
            this.token = query.token
            this.code = ''
            this.state = ''
            
            this.weixin_login = false
            this.teacher_login = true
        } else if (query.code !== undefined && query.state !== undefined) {
            this.token = ''
            this.code = query.code
            this.state = query.state
            
            this.weixin_login = true
            this.teacher_login = false
            this.show_chose_province = false
        } else {
            this.token = ''
            this.code = ''
            this.state = ''
        }
    },
    methods: {
        init(agent_id) {
            if (this.weixin_login === false) {
                this.check_user_info()
            }
            this.get_oss_list(agent_id)
            this.get_sheng_oss_list()
        },
        reset_base_info_after_register_fun() {
            //console.log('reset_base_info_after_register_fun')
            this.$router.push({path: '/'})
        },
        need_login(token) {
            let that = this
            axios.post(
                api.user.need_login, {token: token}
            ).then(function (res) {
                //console.log('--------------need_login----------------')
                //console.log(res)
                //console.log(res.data.data)
                if (res.data.code === 10000) {
                    localStorage.setItem('bind_phone', res.data.data.bind_phone)
                    localStorage.setItem('province_id', res.data.data.province_id)
                    localStorage.setItem('login_type', res.data.data.login_type)
                    localStorage.setItem('over_time', res.data.data.over_time)
                    localStorage.setItem('jwt', res.data.data.token)
                    localStorage.setItem('teacher_login', 1)
                    
                    that.province_id = res.data.data.province_id
                    if (res.data.data.province_id < 1) {
                        //that.$router.push({query: ''})
                        
                        that.edit_user_info.show = true
                    } else {
                        
                        let local_url = that.province_url_list[res.data.data.province_id] || null
                        if (local_url !== null) {
                            axios.defaults.baseURL = local_url
                            localStorage.setItem('local_url', local_url)
                        }
                        
                        that.get_user_info(false, false, true)
                    }
                }
                // else {
                //     ElNotification({
                //         title: '',
                //         message: '老师登录失败',
                //         type: 'error',
                //     })
                // }
            }).catch(function (err) {
            });
        },
        weixin_login_fun() {
            if (this.weixin_login !== true) {
                return false
            }
            let that = this
            let local_url = that.province_url_list[this.province_id] || null
            if (local_url !== null) {
                axios.defaults.baseURL = local_url
            }
            axios.post(api.open_wx.access_token, {code: this.code, state: this.state}).then(function (res) {
                if (res.data.code === 10000) {
                    localStorage.setItem('bind_phone', res.data.data.bind_phone)
                    localStorage.setItem('province_id', res.data.data.province_id)
                    localStorage.setItem('jwt', res.data.data.token)
                    localStorage.setItem('login_type', res.data.data.login_type)
                    localStorage.setItem('over_time', res.data.data.over_time)
                    
                    // console.log('-------------------res.data.data.bind_phone----------------')
                    // console.log(res.data.data)
                    if (res.data.data.bind_phone < 1) {
                        that.$emit('change_bind_phone', {'show_bind_phone': 1})
                    } else if (res.data.data.province_id < 1) {
                        that.edit_user_info.show = true
                    } else {
                        
                        let local_url = that.province_url_list[res.data.data.province_id] || null
                        if (local_url !== null) {
                            axios.defaults.baseURL = local_url
                        }
                        that.province_id = res.data.data.province_id
                        
                        // console.log('---------------axios.post(api.open_wx.access_token----------------')
                        that.get_user_info(true, false, true)
                    }
                    
                } else {
                }
            }).catch(function (err) {
            });
        },
        hangyezixun() {
            // window.open("https://news.shudaozaixian.com/zixun/")
        },
        hangyezixun_xiangqing(item) {
            let page = this.$router.resolve({
                path: '/article_info',
                query: {
                    id: item.id,
                    title: item.title,
                    agent_id: this.agent_id,
                    keys: item.key,
                }
            })
            window.open(page.href, '_blank')
        },
        zuixin_zixun_first() {
            let page = this.$router.resolve({
                path: '/article_info',
                query: {
                    id: this.zuixin_zixun.id,
                    title: this.zuixin_zixun.title,
                    agent_id: this.agent_id,
                    keys: this.zuixin_zixun.key,
                }
            })
            window.open(page.href, '_blank')
        },
        zhuanjiatuandui() {
            this.$router.push({path: '/news', query: {'type': 'zhuanjia_tuandui'}})
        },
        zhuanjiatuandui_xiangqing(item) {
            let page = this.$router.resolve({
                path: '/article_info',
                query: {
                    id: item.id,
                    title: item.title,
                    agent_id: this.agent_id,
                    keys: item.key,
                }
            })
            window.open(page.href, '_blank')
        },
        zhengcejiedu(item) {
            this.$router.push({path: '/news', query: {'type': 'zhengce_jiedu'}})
        },
        zuixin_zixun_fun(item) {
            this.$router.push({path: '/news', query: {'type': 'zuixin_zixun'}})
        },
        zhengce_xiangqing(item) {
            let page = this.$router.resolve({
                path: '/article_info',
                query: {
                    id: item.id,
                    title: item.title,
                    agent_id: this.agent_id,
                    keys: item.key,
                }
            })
            window.open(page.href, '_blank')
        },
        shujufenxi() {
            this.$router.push({path: '/news', query: {'type': 'shuju_fenxi'}})
        },
        shujufenxi_xiangqing(item) {
            let page = this.$router.resolve({
                path: '/article_info',
                query: {
                    id: item.id,
                    title: item.title,
                    agent_id: this.agent_id,
                    keys: item.key,
                }
            })
            window.open(page.href, '_blank')
        },
        mingshijiangtang() {
            this.$router.push({path: '/news', query: {'type': 'mingshi_jiangtang'}})
        },
        mingshijiangtang_xiangqing(item) {
            let page = this.$router.resolve({
                path: '/article_info',
                query: {
                    id: item.id,
                    title: item.title,
                    agent_id: this.agent_id,
                    keys: item.key,
                }
            })
            window.open(page.href, '_blank')
        },
        check_user_info() {
            let base_info = localStorage.getItem('base_info') || ''
            if (base_info !== null && base_info !== 'null' && base_info !== '[]' && base_info !== '' && base_info !== 'undefined') {
                base_info = JSON.parse(base_info)
                this.province_id = base_info.province_id
                this.province_name = base_info.province_name
                this.show_chose_province = false
                if(this.province_id == 46){
                    this.score_input_max = 900
                }else{
                    this.score_input_max = 750
                }
            } else {
                let chose_province_id = localStorage.getItem('chose_province_id')
                if (chose_province_id !== null && chose_province_id !== undefined && chose_province_id > 0) {
                    chose_province_id = parseInt(chose_province_id)
                    if(chose_province_id === 46){
                        this.score_input_max = 900
                    }else{
                        this.score_input_max = 750
                    }
                    this.show_chose_province = false
                    this.province_id = chose_province_id
                    this.province_name = localStorage.getItem('chose_province_name') || ''
                }
            }
        },
        before_close() {
        },
        right_click_fun(item) {
            //console.log(item)
            let label = item.label
            if (label === '一分一档') {
                this.$router.push({path: '/tools', query: {'type': 'yifenyidang'}})
            }
            if (label === '批次线') {
                this.$router.push({path: '/tools', query: {'type': 'picixian'}})
            }
            if (label === '查大学') {
                this.$router.push({path: '/tools', query: {'type': 'daxue'}})
            }
            if (label === '查专业') {
                this.$router.push({path: '/tools', query: {'type': 'zhuanye'}})
            }
            if (label === 'AI选专业') {
                this.$router.push({path: '/assess_info'})
            }
            if (label === '测录取') {
                this.$router.push({path: '/chose_batch'})
            }
        },
        left_click_fun(item) {
            let label = item.label
            if (label === '填写信息') {
                this.$router.push({path: '/personal', query: {}})
            }
            if (label === 'AI选专业') {
                this.$router.push({path: '/assess_info', query: {}})
            }
            if (label === '选志愿') {
                this.$router.push({path: '/chose_batch', query: {}})
            }
            if (label === '评估报告') {
                this.$router.push({path: '/intention', query: {}})
            }
        },
        chose_plan() {
            this.$router.push({path: '/chose_batch', query: {}})
        },
        show_school_info(item) {
            console.log(item)
            let routeData = this.$router.resolve({
                path: '/school_info',
                query: {school_id: item.school_id, school_name: item.name, from: 1}
            })
            window.open(routeData.href, '_blank');
        },
        close_edit_user_info() {
            //console.log('------------home-close_edit_user_info------------')
            this.edit_user_info.show = false
            if (this.$route.query.token !== undefined) {
                this.$router.push({query: ''})
            } else {
                this.$router.go(0)
            }
        },
        chose_gaokao_sheng(index, item) {
            if(item.use === false){
                return false
            }
            if(this.score_precedence_1.length < 1 && this.score_precedence_2.length < 1 && this.score_precedence_3.length < 1){
                this.loading = true
            }
            this.province_id = item.id
            this.province_name = item.name
            this.chose_province_status = false
            this.show_chose_province = false
            if(this.province_id == 46){
                this.score_input_max = 900
            }else{
                this.score_input_max = 750
            }
            localStorage.setItem('chose_province_id', item.id)
            localStorage.setItem('chose_province_name', item.name)
            this.province_change(this.province_id)
            //console.log('------------chose_gaokao_sheng-----------------')
            this.get_sheng_oss_list()
        },
        chose_province_fun() {
            this.chose_province_status = true
        },
        changeTab(val) {
            this.tab = val;
        },
        get_sheng_oss_list() {
            let that = this
            if(this.score_precedence_1.length < 1 && this.score_precedence_2.length < 1 && this.score_precedence_3.length < 1){
                this.loading = true
            }
            let url = api.oss.sheng_list.replace('placeholder', this.province_id) + '?t=' + (Date.now() + '')
            
            axios.get(
                url, {}
            ).then(function (res) {
                let url_list = []
                url_list.push(axios.get(res.data.score_precedence.replace('placeholder', that.province_id + '/1')))
                url_list.push(axios.get(res.data.score_precedence.replace('placeholder', that.province_id + '/zhuan_1')))
                url_list.push(axios.get(res.data.score_precedence.replace('placeholder', that.province_id + '/2')))
                url_list.push(axios.get(res.data.score_precedence.replace('placeholder', that.province_id + '/zhuan_2')))
                url_list.push(axios.get(res.data.score_precedence.replace('placeholder', that.province_id + '/3')))
                url_list.push(axios.get(res.data.score_precedence.replace('placeholder', that.province_id + '/zhuan_3')))
                axios.all(url_list).then(
                    result => {
                        that.score_precedence_1 = result[0]['data']
                        that.score_precedence_1_zhuan = result[1]['data']
                        that.score_precedence_2 = result[2]['data']
                        that.score_precedence_2_zhuan = result[3]['data']
                        that.score_precedence_3 = result[4]['data']
                        that.score_precedence_3_zhuan = result[5]['data']
                        that.loading = false
                    }
                ).catch(() => {
                })
            }).catch(function (err) {
            });
        },
        get_areas() {
            //console.log(this.oss_url_list.areas)
            let that = this
            axios.get(
                this.oss_url_list.areas, {}
            ).then(function (res) {
                //console.log('---------------get_areas----------------')
                //console.log(res.data)
                that.cities = res.data.cities
                that.areas = res.data.areas
                that.all_provinces = res.data.province
                
                that.provinces = []
                for (let i in that.all_provinces) {
                    if (that.gaokaomoshi[i] !== undefined) {
                        if(that.agent_open_province.length > 0){
                            if (that.agent_open_province.indexOf(parseInt(i)) > -1) {
                                that.provinces.push({name: that.all_provinces[i], id: i, use: true})
                            } else {
                                that.provinces.push({name: that.all_provinces[i], id: i, use: false})
                            }
                        }else{
                            that.provinces.push({name: that.all_provinces[i], id: i, use: true})
                        }
                    }
                }
                
                if (that.base_info.province_id > 0) {
                    that.chose_cities = that.cities[that.base_info.province_id]
                }
                if (that.base_info.city > 0 || that.base_info.city !== '') {
                    that.chose_areas = that.areas[that.base_info.city]
                }
            }).catch(function (err) {
                //console.log(err)
                that.$notify.error({
                    title: '未知错误',
                    message: '未知错误',
                    offset: 50,
                });
            });
        },
        cities_change(v) {
            //console.log(this.areas[v])
            this.chose_areas = this.areas[v]
            this.base_info.address = ''
            this.base_info.city_str = this.chose_cities[v]
        },
        get_oss_list(agent_id) {
            let that = this
            axios.get(
                api.oss.list + '?t=' + (Date.now() + ''), {}
            ).then(function (res) {
                that.gaokaomoshi_url = res.data.gaokaomoshi
                that.gaokaoxuanke_url = res.data.gaokaoxuanke
                that.areas_url = res.data.areas
                
                that.oss_url_list = res.data
                that.get_gaokaomoshi()
                that.get_user_agreement(agent_id)
                
                that.get_province_url()
            }).catch(function (err) {
            });
        },
        get_province_url() {
            let that = this
            let province_id = localStorage.getItem('province_id') || 0
            
            axios.get(
                that.oss_url_list.province_url, {}
            ).then(function (res) {
                that.province_url_list = res.data
                
                let local_url = that.province_url_list[province_id] || null
                if (local_url !== null) {
                    axios.defaults.baseURL = local_url
                }
                
                localStorage.setItem('province_url_list', JSON.stringify(that.province_url_list))
                
                let login_type = localStorage.getItem('login_type')
                let bind_phone = localStorage.getItem('bind_phone')
                if (bind_phone !== null && bind_phone < 1) {
                    that.get_user_info(true)
                } else if (that.weixin_login) {
                    that.weixin_login_fun()
                } else if (that.teacher_login) {
                    that.need_login(that.token)
                }
            }).catch(function (err) {
            });
        },
        get_gaokaoxuanke() {
            let that = this
            axios.get(
                that.oss_url_list.gaokaoxuanke, {}
            ).then(function (res) {
                that.gaokaoxuanke_list = res.data
                localStorage.setItem('gaokaoxuanke', JSON.stringify(res.data))
                
                if (that.province_id > 0) {
                    that.gaokaoxuanke = that.gaokaoxuanke_list[that.province_id] || {
                        'major_1nd': [],
                        'major_2nd': [],
                        'majors': [],
                        'score_prediction': [],
                    }
                }
                that.show_major_1nd = that.gaokaoxuanke.major_1nd.length >= 1;
                that.show_major_2nd = that.gaokaoxuanke.major_2nd.length >= 1;
                that.show_score_prediction = that.gaokaoxuanke.score_prediction.length > 1;
                
                //console.log(that.show_major_1nd)
                //console.log(that.show_major_2nd)
                //console.log(that.show_score_prediction)
                
                that.province_change(that.province_id)
            }).catch(function (err) {
            });
        },
        get_gaokaomoshi() {
            
            //console.log('-----------------get_gaokaomoshi----------------')
            let that = this
            axios.get(
                that.oss_url_list.gaokaomoshi, {}
            ).then(function (res) {
                that.gaokaomoshi = res.data
                //console.log('------------that.gaokaomoshi----------')
                that.get_gaokaoxuanke()
                
                that.get_areas()
                
                if (that.province_id > 0) {
                    let type = that.gaokaomoshi[that.province_id] || 0
                    that.gaokaomoshi_type = parseInt(type)
                    that.set_info_from_storage()
                }
            }).catch(function (err) {
            });
        },
        get_user_agreement(agent_id) {
            let that = this
            let url = that.oss_url_list.user_agreements
            if(url.indexOf('placeholder') > -1){
                url = url.replace('placeholder', agent_id)
            }
            
            axios.get(
                url, {}
            ).then(function (res) {
                localStorage.setItem('user_agreement', res.data)
            }).catch(function (err) {
            });
        },
        set_info_from_storage() {
            this.base_info.subject_one = parseInt(this.base_info.subject_one)
            this.base_info.subject_two = parseInt(this.base_info.subject_two)
            this.base_info.subject_three = parseInt(this.base_info.subject_three)
            let subject_three = this.base_info.subject_three
            
            //console.log('-------------------------------------')
            //console.log(this.gaokaomoshi_type)
            
            if (this.gaokaomoshi_type === 1) {
                if (this.base_info.subject_two > 0 && this.base_info.subject_one > 0) {
                    this.base_info.second = [this.base_info.subject_two, this.base_info.subject_one]
                } else {
                    this.base_info.second = []
                }
            } else if (this.gaokaomoshi_type === 2) {
                this.major_2nd_limit = 3
                if (this.base_info.subject_two > 0 && this.base_info.subject_three > 0 && this.base_info.subject_one > 0) {
                    this.base_info.second = [this.base_info.subject_three, this.base_info.subject_two, this.base_info.subject_one]
                } else {
                    this.base_info.second = []
                }
            } else if (this.gaokaomoshi_type === 3) {
                this.base_info.second = []
                // {id: 8, name: "文科"}, {id: 9, name: "理科"}
                if (subject_three === 1) {
                    this.base_info.subject_three = 9
                } else if (subject_three === 2) {
                    this.base_info.subject_three = 8
                }
            }
        },
        province_change(e) {
            
            //console.log('-----------------province_change------------------')
            
            let type = this.gaokaomoshi[e] || 0
            this.gaokaoxuanke = this.gaokaoxuanke_list[e] || {'major_1nd': {}, 'major_2nd': {}, 'majors': {},}
            this.gaokaomoshi_type = parseInt(type)
            if (this.gaokaomoshi_type === 1) {
                this.major_2nd_limit = 2
            } else if (this.gaokaomoshi_type === 2) {
                this.major_2nd_limit = 3
            }
            
            //console.log('-----------------this.gaokaomoshi_type------------------')
            //console.log(this.gaokaomoshi_type)
            //console.log('-----------------this.major_2nd_limit------------------')
            //console.log(this.major_2nd_limit)
            
            this.show_major_1nd = this.gaokaoxuanke.major_1nd.length >= 1;
            this.show_major_2nd = this.gaokaoxuanke.major_2nd.length >= 1;
            this.show_score_prediction = this.gaokaoxuanke.score_prediction.length > 1;
            
            this.chose_cities = this.cities[e]
            this.base_info.city = ''
            
            this.base_info.second = []
            this.base_info.subject_three = 0
            
            //console.log('-----------------province_change end------------------')
        },
        score_input(e) {
            this.base_info.score = parseInt(e.replace(/[^\d]/g, ''))
            if (e === '') {
                this.base_info.score = 0
            }
            if (this.base_info.score > this.score_input_max) {
                this.base_info.score = this.score_input_max
            } else if (this.base_info.score < 0) {
                this.base_info.score = 0
            }
            this.score_change(this.base_info.score)
        },
        precedence_input(e) {
            this.base_info.precedence = parseInt(e.replace(/[^\d]/g, ''))
            //console.log(this.base_info.precedence)
            this.precedence_change(this.base_info.precedence)
        },
        first_xuanke_change(e) {
            this.score_change(this.base_info.score)
        },
        second_xuanke_change(e) {
            //console.log(e)
        },
        score_change(e) {
            let list = []
            if (this.gaokaomoshi_type === 1) {
                if (this.base_info.subject_three === 1) {
                    if (this.base_info.precedence_type == 1) {
                        list = this.score_precedence_2
                    } else {
                        list = this.score_precedence_2_zhuan
                    }
                } else {
                    if (this.base_info.precedence_type == 1) {
                        list = this.score_precedence_3
                    } else {
                        list = this.score_precedence_3_zhuan
                    }
                }
            } else if (this.gaokaomoshi_type === 3) {
                if (this.base_info.subject_three === 9) {
                    if (this.base_info.precedence_type == 1) {
                        list = this.score_precedence_2
                    } else {
                        list = this.score_precedence_2_zhuan
                    }
                } else {
                    if (this.base_info.precedence_type == 1) {
                        list = this.score_precedence_3
                    } else {
                        list = this.score_precedence_3_zhuan
                    }
                }
            } else {
                if (this.base_info.precedence_type == 1) {
                    list = this.score_precedence_1
                } else {
                    list = this.score_precedence_1_zhuan
                }
            }
            let precedence = 0
            for (let i in list) {
                if (e >= list[i]['s']) {
                    precedence = parseInt(list[i]['p'])
                    break;
                }
            }
            this.base_info.precedence = precedence
        },
        prediction_type_change(e) {
            //console.log(this.base_info)
            this.score_change(this.base_info.score)
        },
        precedence_change(e) {
            let precedence = parseInt(e)
            let score = 0
            let list = []
            if (this.gaokaomoshi_type === 1) {
                if (this.base_info.subject_three === 1) {
                    if (this.base_info.precedence_type == 1) {
                        list = this.score_precedence_2
                    } else {
                        list = this.score_precedence_2_zhuan
                    }
                } else {
                    if (this.base_info.precedence_type == 1) {
                        list = this.score_precedence_3
                    } else {
                        list = this.score_precedence_3_zhuan
                    }
                }
            } else if (this.gaokaomoshi_type === 3) {
                if (this.base_info.subject_three === 9) {
                    if (this.base_info.precedence_type == 1) {
                        list = this.score_precedence_2
                    } else {
                        list = this.score_precedence_2_zhuan
                    }
                } else {
                    if (this.base_info.precedence_type == 1) {
                        list = this.score_precedence_3
                    } else {
                        list = this.score_precedence_3_zhuan
                    }
                }
            } else {
                if (this.base_info.precedence_type == 1) {
                    list = this.score_precedence_1
                } else {
                    list = this.score_precedence_1_zhuan
                }
            }
            
            for (let i in list) {
                if (precedence == list[i]['p']) {
                    score = parseInt(list[i]['s'])
                    break;
                } else if (precedence <= list[i]['p']) {
                    score = parseInt(list[i]['s'])
                    break;
                }
            }
        },
        chose_plans(e) {
            let jwt = localStorage.getItem('jwt')
            if (jwt === null || jwt === undefined) {
                this.$emit('change_menu_action', {'from': 'home', 'type': 'show_login'})
            } else {
                this.change_info()
            }
        },
        change_info() {
            let that = this
            
            let time = localStorage.getItem('over_time') || 0
            if (Date.now() / 1000 - time > 360) {
                ElMessageBox.alert('您的登录已超时,请重新登录', '提醒', {
                    confirmButtonClass: 'confirm_button_class',
                    confirmButtonText: '好的',
                    callback: () => {
                        that.$emit('change_menu_action', {'from': 'home', 'type': 'show_login'})
                    },
                })
                return false
            }
            
            let base_info = {...this.base_info}
            
            if (this.gaokaomoshi_type === 1) {
                base_info.subject_two = Math.min(...this.base_info.second)
                base_info.subject_one = Math.max(...this.base_info.second)
            } else if (this.gaokaomoshi_type === 2) {
                base_info.subject_three = Math.min(...this.base_info.second)
                base_info.subject_one = Math.max(...this.base_info.second)
                
                for (let i in base_info.second) {
                    if (base_info.second[i] !== base_info.subject_three && base_info.second[i] !== base_info.subject_one) {
                        base_info.subject_two = base_info.second[i]
                        break
                    }
                }
            } else if (this.gaokaomoshi_type === 3) {
                let majors = this.gaokaoxuanke['majors'][base_info.subject_three]
                base_info.subject_three = Math.min(...majors)
                base_info.subject_one = Math.max(...majors)
                
                for (let i in majors) {
                    if (majors[i] !== base_info.subject_three && majors[i] !== base_info.subject_one) {
                        base_info.subject_two = majors[i]
                        break
                    }
                }
            }
            
            base_info.input_precedence = base_info.precedence
            
            //console.log(base_info)
            
            axios.post(
                api.user.input_score, base_info
            ).then(function (res) {
                //console.log(res)
                //console.log(res.data.data.code)
                // console.log(res.data.data)
                //console.log(res.data.data.code === 10000)
                if (res.data.data.code === 10000) {
                    that.update_user_info()
                } else if (res.data.data.code !== 9999) {
                    ElMessageBox.alert('您的登录已超时,请重新登录', '提醒', {
                        confirmButtonClass: 'confirm_button_class',
                        confirmButtonText: '好的',
                        callback: () => {
                            that.$emit('change_menu_action', {'from': 'home', 'type': 'show_login'})
                        },
                    })
                } else {
                    //console.log('------ElNotification-----')
                    ElNotification({
                        title: '友情提醒',
                        message: res.data.data.msg || '请正确填写选科和分数信息',
                        type: 'error',
                    })
                }
            }).catch(function (err) {
                //console.log(err)
                ElNotification({
                    title: '友情提醒',
                    message: '请正确填写选科和分数信息',
                    type: 'error',
                })
            });
        },
        update_user_info(province_id) {
            let that = this
            axios.post(
                api.user.info, {}
            ).then(function (res) {
                localStorage.setItem('base_info', JSON.stringify(res.data.data))
                that.$router.push({path: '/chose_batch'})
            }).catch(function (err) {
            });
        },
        get_user_info(type = false, show_login = false, flash = false) {
            let that = this
            if (show_login === false) {
                let local_url = that.province_url_list[this.province_id] || null
                if (local_url !== null) {
                    axios.defaults.baseURL = local_url
                    localStorage.setItem('local_url', local_url)
                }
            }
            
            axios.post(
                api.user.info, {}
            ).then(function (res) {
                localStorage.setItem('base_info', JSON.stringify(res.data.data))
                if (res.data.data.province_id < 1) {
                    that.edit_user_info.show = true
                }
                if (res.data.data.length < 1) {
                    that.show_chose_province = false
                    //console.log('-----------res.data.data.bind_phone < 1-------------------')
                    that.$emit('change_bind_phone', {'show_bind_phone': 1})
                }
                if (show_login) {
                    //console.log('-------------------if(show_login){------------------------')
                    that.$emit('change_menu_action', {'from': 'home', 'type': 'no_show_login'})
                    localStorage.setItem('chose_province_id', res.data.data.province_id)
                    localStorage.setItem('chose_province_name', res.data.data.province_name)
                    that.get_gaokaomoshi()
                    
                    that.province_id = res.data.data.province_id
                    that.province_name = res.data.data.province_name
                }
                if (flash) {
                    that.$router.push({query: ''})
                }
            }).catch(function (err) {
            });
        }
    },
};
</script>

<style lang="scss" scoped>

@import "../../style/var.scss";

.banner {
    //width: calc(100% - $width-pdTotal);
    width: 100%;
    height: 500px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center center; /* 将背景图像居中 */
    background-size: cover; /* 保持背景图像的纵横比，同时覆盖整个div */
    background-image: url("../../assets/layout/big_banner.png");
    
    .content {
        width: 1230px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        justify-content: space-between;
        
        .volunteer {
            width: 360px;
            height: calc(100% - 100px);
            padding: 30px;
            margin-top: 20px;
            background: var(--sub-bg);
            box-shadow: -4px 4px 16px 7px #f0a49340;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            
            .tip {
                width: 100%;
                color: #999999;
                font-size: 14px;
                text-align: center;
            }
            
            .title {
                width: 100%;
                font-size: 28px;
                color: #e53e19;
                text-align: center;
                margin-top: 5px;
            }
            
            .select {
                width: 100%;
                height: 60px;
                margin-right: 0;
                border: 1px solid #e1e0e0;
                border-radius: 6px;
                color: #999999;
                margin-top: 10px;
                display: flex;
                align-items: center;
                
                .name {
                    height: 32px;
                    width: 72px;
                    padding: 0 10px;
                    line-height: 32px;
                    font-size: 16px;
                    border-right: 1px solid #d9d9d9;
                }
            }
            
            .ms-button {
                width: 100%;
                height: 50px;
                margin-top: 30px;
                text-align: center;
                line-height: 50px;
                border-radius: 6px;
                font-size: 24px;
            }
        }
    }
}

.container {
    background: var(--sub-bg);
    margin: 0 !important;
    padding-top: 20px;
    
    .tip {
        width: 100%;
        height: 97px;
        margin-top: 40px;
        display: flex;
        
        .left,
        .right {
            width: 432px;
            height: 100%;
            display: flex;
            
            .list {
                display: flex;
                align-items: center;
                font-size: 16px;
                color: #333333;
                
                .icon {
                    width: 10px;
                    height: 16px;
                    margin: 0 22px;
                    margin-top: -25px;
                }
            }
            
            .box {
                width: 66px;
                height: 100%;
                cursor: pointer;
                
                img {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 66px;
                    height: 66px;
                    border-radius: 12px;
                }
            }
            
            .text {
                width: 100%;
                text-align: center;
                margin-top: 10px;
            }
        }
        
        .right {
            width: calc(100% - 432px - 81px);
            display: flex;
            justify-content: space-between;
        }
        
        .cutOff {
            width: 1px;
            height: 94px;
            background: #d9d9d9;
            margin: 0 40px;
        }
    }
}

.category {
    margin-top: 40px;
    margin-bottom: 30px;
}

.school {
    background: linear-gradient(94.75deg, #e93a29 0%, #ef6830 100%);
    width: calc(100% - 40px);
    height: 306px;
    border-radius: 8px;
    padding: 20px !important;
    display: flex;
    overflow: hidden;
    justify-content: space-between;
    
    .left {
        display: flex;
        width: 254px;
        height: 100%;
        margin-left: 20px;
        flex-direction: column;
        color: #fff;
        
        .font1 {
            width: 210px;
            line-height: 45px;
            font-size: 30px;
            margin-top: 30px;
        }
        
        .cutOff {
            width: 46px;
            height: 3px;
            background: var(--sub-bg);
            margin-top: 10px;
            margin-bottom: 10px;
        }
        
        .font2 {
            width: 254px;
            line-height: 30px;
            font-size: 18px;
        }
        
        .button {
            width: 192px;
            height: 48px;
            background: var(--sub-bg);
            cursor: pointer;
            color: #ea3e2a;
            font-size: 20px;
            border-radius: 4px;
            text-align: center;
            margin-top: 30px;
            line-height: 48px;
        }
    }
    
    .right {
        width: 818px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        overflow: hidden;
        
        .list {
            display: flex;
            cursor: pointer;
            width: 270px;
            height: 98px;
            border-radius: 6px;
            font-size: 18px;
            color: #000000;
            background: var(--sub-bg);
            align-items: center;
            
            img {
                width: 70px;
                height: 70px;
                margin-right: 10px;
                margin-left: 20px;
            }
            
            div {
                width: calc(100% - 120px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.teacher {
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    border-radius: 10px;
    justify-content: left;
    
    .list {
        width: 32%;
        height: 310px;
        border-radius: 10px;
        cursor: pointer;
        margin: 0 15px 20px 0;
        box-shadow: 0px 4px 18px 0px #0000001a;
        
        img {
            width: 100%;
            height: 216px;
        }
        
        .content {
            padding: 0 20px;
            
            .top {
                font-size: 20px;
                color: #000000;
                margin-top: 10px;
            }
            
            .bottom {
                font-size: 14px;
                line-height: 21px;
                color: #999999;
                margin-top: 5px;
                display: -webkit-box;
                overflow: hidden;
                -webkit-box-orient: vertical;
                line-clamp: 2;
                -webkit-line-clamp: 2;
            }
        }
    }
}

.expert {
    width: 100%;
    display: flex;
    border-radius: 10px;
    flex-wrap: wrap;
    justify-content: stretch;
    
    img {
        width: 382px;
        height: 200px;
    }
}

.block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    
    .left {
        width: 800px;
    }
    
    .right {
        width: 350px;
    }
}

.industry {
    width: 100%;
    
    .first,
    .list {
        display: flex;
        
        .left {
            width: 380px;
            height: 100%;
            margin-right: 20px;
            border-radius: 6px;
        }
        
        .right {
            width: calc(100% - 400px);
            display: flex;
            justify-content: center;
            flex-direction: column;
            
            .title {
                font-size: 20px;
                color: #333333;
            }
            
            .content,
            .time {
                font-size: 14px;
                color: #999999;
            }
            
            .content {
                display: -webkit-box;
                overflow: hidden;
                -webkit-box-orient: vertical;
                line-clamp: 3;
                -webkit-line-clamp: 3;
                margin-top: 20px;
                margin-bottom: 30px;
            }
            
            .time {
                display: flex;
                
                div:nth-of-type(2) {
                    margin: 0 5px;
                }
            }
        }
    }
    
    .list {
        display: flex;
        margin-top: 20px;
        
        .left {
            width: 190px;
            height: 132px;
        }
        
        .right {
            width: calc(100% - 210px);
            
            .content {
                line-clamp: 2;
                -webkit-line-clamp: 2;
                margin-top: 5px;
                margin-bottom: 15px;
            }
        }
    }
}

.policy {
    width: 100%;
    
    img {
        width: 350px;
        cursor: pointer;
        height: 150px;
    }
    
    .ranking {
        width: 100%;
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        display: flex;
        cursor: pointer;
        align-items: center;
        
        div:nth-of-type(1) {
            font-size: 16px;
            color: #999999;
            width: 20px;
            height: 30px;
            text-align: center;
        }
        
        div:nth-of-type(2) {
            width: 300px;
            margin: 5px;
            color: #333333;
            font-size: 18px;
            white-space: nowrap; //不换行
            overflow: hidden; //超出隐藏
            text-overflow: ellipsis //超出文本省略号;
        }
    }
}

.more {
    cursor: pointer;
}

.analyze {
    width: 100%;
    color: #000000;
    font-size: 20px;
    font-weight: 500;
    
    .list {
        margin-bottom: 25px;
        cursor: pointer;
        
        img {
            width: 100%;
            height: 198px;
            margin-bottom: 5px;
        }
        
        div {
            white-space: nowrap; //不换行
            overflow: hidden; //超出隐藏
            text-overflow: ellipsis //超出文本省略号;
        }
    }
}

.gaokao_sheng {
    height: 30px;
    line-height: 30px;
    width: 150px;
    border: 1px white solid;
    border-radius: 5px;
    text-align: center;
    margin: 5px;
    color: white;
    cursor: pointer;
    overflow: hidden;
    padding: 0 5px;
}

.gaokao_sheng_no_chose {
    height: 30px;
    line-height: 30px;
    width: 150px;
    border: 1px #666666 solid;
    border-radius: 5px;
    text-align: center;
    margin: 5px;
    color: #666666;
    overflow: hidden;
    padding: 0 5px;
}

.gaokao_sheng:hover {
    border: 1px #b5b5b5 solid;
    color: #b5b5b5;
}
</style>
